import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { LoginComponent } from './login/login.component';
import { VersionComponent } from './shared/components/version/version.component';
import { UnlicensedComponent } from './shared/components/unlicensed/unlicensed.component';
import { RenderReportComponent } from './render-report/render-report.component';
import { DecodeQrComponent } from './decode-qr/decode-qr.component';


const routes: Routes = [
  { path: 'decode-qr', component: DecodeQrComponent },
  { path: 'decodeqr.html', component: DecodeQrComponent },
  { path: 'unlicensed', component: UnlicensedComponent },
  { path: 'RenderReport', component: RenderReportComponent },
  { path: 'RenderReport.aspx', component: RenderReportComponent },
  { path: '', loadChildren: () => import(`./modules/modules.module`).then(r => r.ModulesModule) },
  { path: 'account', loadChildren: () => import(`./account/accounts.module`).then(r => r.AccountsModule) },
  { path: 'common', loadChildren: () => import(`./common/common.module`).then(r => r.CommonModule) },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'login', component: LoginComponent },
  { path: 'version', component: VersionComponent },
  { path: 'deployment', loadChildren: () => import('./modules/deployment/deployment.module').then(r => r.DeploymentModule) }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { enableTracing: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
